import type { SectionTab } from 'v2/shared/components/section-tabs'

export type SipTrunkingTab = 'inbound' | 'outbound'

export const SIP_TRUNKING_TAB_COPY: Record<SipTrunkingTab, SectionTab> = {
  inbound: {
    title: 'Inbound trunks',
    description: 'Manage SIP trunks that receive incoming calls.',
  },
  outbound: { title: 'Outbound trunks', description: 'Manage SIP trunks for outbound telephony.' },
}
